var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dashboard',{attrs:{"profileID":_vm.configDashboard.profile_id}})
}
var staticRenderFns = []

export { render, staticRenderFns }